import { createReducer, on } from "@ngrx/store";
import { ActivityReportTableActions } from "../actions";
import { MasterTransactionsTableActions } from "../actions";
import { ActivityReportResponse } from "../models/master-status-view/ActivityReportResponse";
import { JsonApiListWrap } from "../../shared/models/JsonApiWrap";
import { ActivityReport, ActivityReportState } from "../models/master-status-view/ActivityReportState";

export const activityReportKey = 'activityReport';

export interface State extends ActivityReportState { }

export const initialActivityReportState: State = {
  activityReports: [],
  loading: false,
  error: "",
  hasError: false,
}


export const activityReportReducer = createReducer(
  initialActivityReportState,
  on(ActivityReportTableActions .getActivityReports, (state) => {
    return {
      ...initialActivityReportState
    }
  }),
  on(
    ActivityReportTableActions .callActivityReportsSuccess,
    (state, response) => {
      return {
        ...state,
        activityReports: [...mapActivityReports(response)]
      }
    }),
  on(
    MasterTransactionsTableActions.currentTabUpdated,
    (state) => {
      return {
        ...state,
        activityReports: []
      }
    }),
  on(
    ActivityReportTableActions .getActivityReports,
    MasterTransactionsTableActions.currentTabUpdated,
    (state) => {
      return {
        ...state,
      }
    }),
  on(ActivityReportTableActions .callActivityReportsFailure, (state, err) => {
    return {
      ...state,
      loading: false,
      error: err.message,
      hasError: true,
    }
    })
)



function mapActivityReports(activityReportsResponse: JsonApiListWrap<ActivityReportResponse>): ActivityReport[] {
  return activityReportsResponse.data.map((report) => {
    return {
      id: report.id,
      interimSeqId: report.attributes?.interimSeqId,
      description: report.attributes.linkDescription
    } as ActivityReport;
  })
};
